import { render, staticRenderFns } from "./form-radio-group.vue?vue&type=template&id=7832ab54"
import script from "./form-radio-group.vue?vue&type=script&lang=js"
export * from "./form-radio-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports